import { BrowserRouter } from "react-router-dom";
import type { QueryClient } from "@tanstack/react-query";
import i18n from "@/lib/i18n";
import { applyConsentToSdks } from "@/lib/consentedSdks";
import { initConsentMode, restoreConsent, parseStoredConsent } from "@/lib/analytics";
import AppShell from "./AppShell";

// GA4 consent mode — defaults to denied, re-applies any saved choice.
// Both no-op in dev / when no measurement ID is configured.
initConsentMode();
restoreConsent();

// Non-essential SDKs (Sentry, OneSignal) boot ONLY if the user has already
// consented — never before consent (#171). Later grants are applied in
// CookieConsent. SSR-safe: no localStorage on the server → nothing inits.
applyConsentToSdks(
  parseStoredConsent(typeof localStorage === "undefined" ? null : localStorage.getItem("cookie-consent")) ??
    {analytics: false, marketing: false}
);

interface AppProps {
  queryClient: QueryClient;
}

// The page itself lives in AppShell, shared with the SSR sidecar so the server
// HTML and the browser's first render cannot drift apart.
const App = ({ queryClient }: AppProps) => (
  <AppShell
    i18n={i18n}
    queryClient={queryClient}
    router={(children) => <BrowserRouter>{children}</BrowserRouter>}
  />
);

export default App;
